import {Product} from '../models/Product';
export const LOAD_PRODUCTS = 'LOAD_PRODUCTS';
export const LOAD_PRODUCTS_SUCCESS = 'LOAD_PRODUCTS_SUCCESS';
export const FETCH_PRODUCTS_FAILED = 'FETCH_PRODUCTS_FAILED';

export class LoadProductsAction {
  readonly type = LOAD_PRODUCTS;
}

export class LoadProductsSuccessAction {
  readonly type = LOAD_PRODUCTS_SUCCESS;
  constructor(public payload: Product[]) { }
}

export class LoadProductsFailedAction {
  readonly type = FETCH_PRODUCTS_FAILED;
}

export type ProductAction =
  LoadProductsAction |
  LoadProductsSuccessAction |
  LoadProductsFailedAction;



// WEBPACK FOOTER //
// C:/Users/majli/reposales365/sale365/src/app/actions/products.actions.ts